import '../i18n'

import { disableStaticPageGeneration } from '@lib/ssrMode'
import { H3 } from '@utils/typography'
import { NextPage } from 'next'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

const DEFAULT_PATH = '/tickets/attendees'

const Home: NextPage = () => {
  const router = useRouter()
  const path = DEFAULT_PATH

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    router.push(path)
  })

  return (
    <H3>
      Redirecting to{' '}
      <Link href={path}>
        <a>{path}</a>
      </Link>
    </H3>
  )
}
disableStaticPageGeneration(Home)

export default Home
